import { GetterTree } from "vuex";
import { getCookie } from "tiny-cookie";
import { RootState } from "@/types/index";
import { LoginState } from "@/types/login";

export const getters: GetterTree<LoginState, RootState> = {
  redirectUrl: () => getCookie("redirect_url") || null,
};
export default getters;
